import React, { useState } from "react";
import { Col, Collapse, Input, Label, Row } from "reactstrap";

const AddMoreDetails = ({
  formData,
  onChange,
  errors,
  onNumberInputChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="w-100">
      <div className="m-auto text-end">
        <button
          className="btn btn-link my-link-btn text-underline"
          type="button"
          onClick={toggle}
        >
          {isOpen ? "Hide more details" : "Show more details"}
        </button>
      </div>

      <Collapse isOpen={isOpen}>
        <Row className="mt-2">
          {/* ✅ ownerName */}
          <Col lg={6}>
            <div className="mb-4">
              <label htmlFor="ownerName" className="form-label">
                Owner Name
              </label>
              <Input
                type="text"
                className="form-control"
                id="ownerName"
                placeholder="Owner Name"
                value={formData?.ownerName}
                onChange={onChange}
                name="ownerName"
                invalid={errors.ownerName ? true : false}
              />
            </div>
          </Col>

          {/* companyType */}
          <Col lg={6}>
            <div className="mb-4">
              <Label htmlFor="companyType" className="form-label">
                Company Type
              </Label>
              <Input
                type="select"
                className="form-select"
                name="companyType"
                id="companyType"
                value={formData.companyType}
                onChange={onChange}
              >
                <option value="">Select Type</option>
                <option value="Hotel">Hotel</option>
                <option value="Restraunt">Restraunt</option>
                <option value="Cafe">Cafe</option>
                <option value="Resort">Resort</option>
                <option value="CloudKitchen">Cloud Kitchen</option>
                <option value="BanquetHall">Banquet Hall</option>
                <option value="Industial/Corporate/HospitalCanteen">
                  Industial /Corporate /Hospital Canteen
                </option>
                <option value="Other">Other</option>
              </Input>
            </div>
          </Col>

          {/* ✅ totalEmployees */}
          <Col lg={6}>
            <div className="mb-4">
              <label className="form-label">Total Employees</label>
              <Input
                type="number"
                className="form-control"
                placeholder="Total Employees"
                value={formData?.totalEmployees}
                onChange={onNumberInputChange}
                name="totalEmployees"
              />
            </div>
          </Col>

          {/* contactNumber */}
          <Col lg={6}>
            <div className="mb-4">
              <Label className="form-label">Phone Number</Label>
              <Input
                type="tel"
                className="form-control"
                placeholder="Phone Number"
                name="contactNumber"
                value={formData?.contactNumber}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);

                  onNumberInputChange({
                    target: {
                      name: "contactNumber",
                      value,
                    },
                  });
                }}
              />
            </div>
          </Col>

          {/* establishmentYear */}
          <Col lg={6}>
            <div className="mb-4">
              <label className="form-label">Establishment Year</label>
              <Input
                type="number"
                className="form-control"
                placeholder="Establishment Year"
                value={formData?.establishmentYear}
                onChange={onNumberInputChange}
                name="establishmentYear"
              />
            </div>
          </Col>

          {/* gstNumber */}
          <Col lg={6}>
            <div className="mb-4">
              <label className="form-label">
                GST Number{" "}
                <small className="text-muted">
                  (Optional – Enter if you require a Tax Invoice)
                </small>
              </label>
              <Input
                type="text"
                className="form-control"
                placeholder="GST Number"
                value={formData?.gstNumber}
                onChange={onChange}
                name="gstNumber"
              />
            </div>
          </Col>

          {/* ✅ websiteUrl */}
          <Col lg={12}>
            <div className="mb-4">
              <label className="form-label">Website Url</label>
              <Input
                type="text"
                className="form-control"
                placeholder="Website Url"
                value={formData?.websiteUrl}
                onChange={onChange}
                name="websiteUrl"
              />
            </div>
          </Col>

          {/* ✅ mapLocation */}
          {/* <Col lg={12}>
            <div className='mb-4'>
              <label className='form-label'>Map Location</label>
              <Input
                type='textarea'
                className='form-control'
                rows='3'
                placeholder='Google map embed link'
                value={formData?.mapLocation}
                onChange={onChange}
                name='mapLocation'
              />
            </div>
          </Col> */}

          {/* ✅ workingDays */}
          {/* <Col lg={12}>
            <div className='mb-4'>
              <label className='form-label'>Working Days</label>
              <Input
                type='textarea'
                rows='7'
                className='form-control'
                placeholder='Monday => 9AM-5PM ...'
                value={formData?.workingDays}
                onChange={onChange}
                name='workingDays'
              />
            </div>
          </Col> */}
        </Row>
      </Collapse>
    </div>
  );
};

export default AddMoreDetails;
